import {
  useCDAAuthorize,
  useCDACheck,
  useCDALogin as useCDALoginHook,
} from '@vfit/consumer/data-access';

export const useCDALogin = () => {
  const {
    mutate: startAuthorize,
    error: errorAuthorize,
    data: authorizeData,
    isLoading: isLoadingAuthorize,
    isSuccess: isSuccessAuthorize,
    isError: isErrorAuthorize,
  } = useCDAAuthorize();

  const {
    mutate: startLogin,
    data: loginData,
    error: loginError,
    isSuccess: isSuccessCDALogin,
    isError: isErrorCDALogin,
  } = useCDALoginHook();

  const {
    mutate: startCheckStatus,
    data: checkStatusData,
    error: checkStatusError,
    isSuccess: isSuccessCDACheckStatus,
    isError: isErrorCDACheckStatus,
  } = useCDACheck();

  return {
    startAuthorize,
    errorAuthorize,
    authorizeData,
    isLoadingAuthorize,
    isSuccessAuthorize,
    isErrorAuthorize,
    startLogin,
    loginData,
    loginError,
    isSuccessCDALogin,
    isErrorCDALogin,
    startCheckStatus,
    checkStatusData,
    checkStatusError,
    isSuccessCDACheckStatus,
    isErrorCDACheckStatus,
  };
};
